angular.module('unica_notification_template.notification_template_controllers', [])

.controller('NotificationTemplateBasicController',
	function(
		$rootScope, $scope, $stateParams, $filter, $timeout,
		$uibModal, $confirm,
		NotificationTemplateListService, NotificationTemplatePreviewService, NotificationTemplateEditService
	) {

	$scope.forms = {};

	$scope.resetNotificationTemplateData = function()
	{
		$scope.notificationTemplateData = {
			event_id: $stateParams.event_id,
		};
	};

	$scope.notificationType = null;
	$scope.$on('event_loaded', function() {
		$scope.notificationType = $rootScope.eventData.notification_type;
	});

	$scope.getNotificationTemplate = function(notificationTemplateId)
	{
		$scope.showLoader();

		NotificationTemplateListService
			.get(notificationTemplateId)
			.then(function(data) {
				$scope.hideLoader();

				$scope.notificationTemplateData = data;

				$scope.$broadcast('notification_template_loaded');
			});
	};


	/**
	 * FUNCTIONS FOR AUTOCOMPLETE USER FOR PREVIEW
	 */

	$scope.searchText = '';

	$scope.searchServiceUser = function(query)
	{
		return query ? $filter('filter')($rootScope.servicesUsers, {label: query}) : $rootScope.servicesUsers;
	};

	$scope.selectedServiceUser = function(service)
	{
		if ( service ) {
			$scope.previewNotificationTemplateData.user_id = service.id;
		} else {
			$scope.previewNotificationTemplateData.user_id = null;
		}
	};


	/**
	 * FUNCTIONS FOR PREVIEW FUNCTIONALITY
	 */
	$scope.previewNotificationTemplateData = {
		user_id: null
	};

	$scope.checkPreviewNotificationTemplateForm = function()
	{
		return ( !$scope.previewNotificationTemplateData.user_id ? true : false );
	};

	$scope.previewNotificationTemplate = function()
	{
		$rootScope.showLoader();

		NotificationTemplatePreviewService
			.preview( $scope.notificationTemplateData.id, $scope.previewNotificationTemplateData.user_id )
			.then(function(data) {
				$rootScope.hideLoader();

				if ( data ) {
					$scope.showSuccessMsg('Anteprima inviata con successo!', '');
				}
			});
	};

});